import React, { useState } from "react";
import NxtbnModal from "../../Modal";
import SelectStyled from "../../Select";
import { InputField } from "../../common";
import countryList from "react-select-country-list";
import useApi from "../../../api";
import { toast } from "react-toastify";


interface Props {
    edit?:any;
    isOpen: boolean;
    onClose: ()=>void;
    taxClassId?: number;
    refresh: ()=>void;
  }

function TaxRateForm({edit, isOpen, onClose, taxClassId, refresh}: Props) {
    const api = useApi()
    const [formData, setFormData] = useState<any>(edit ? { tax_class: taxClassId, ...edit} : { tax_class: taxClassId})
    const [errorData, setErrorData] = useState<any>()

    const country = countryList().getData()
    const [taxClass, setTaxClass] = useState<any>();

    const getDetailTaxClass = () => {
        api.getTaxClassById(taxClassId).then((response: any) => setTaxClass(response)).catch((error: any) => toast.error("Error Fetch tax class !!"));
      };

    const onTaxRateChange = (data: any, index: number) => {
        setFormData((prevFormData: any) => {
          const updatedVariants = [...(prevFormData.tax_rates || [])];
          updatedVariants[index] = data;
      
          return {
            ...prevFormData,
            tax_rates: updatedVariants
          };
        });
      };
    
      const onSelectHandler = (e:any) => {
        setFormData((prev:any)=> ({...prev, country: e.value}))
      }
    
      const onChangeHandler = (e:any) => {
        const {name, value} = e.target 
        setFormData((prev:any)=>({...prev, [name]: value}))
      }
    
      const onSubmit = (e:any, id?:number) => {
        e.preventDefault()
        if (!edit) { 
          api.createTaxRate(formData).then((response:any)=>{
            toast.success('Tax class created')
            
            getDetailTaxClass()
            setFormData({tax_rates:[{}]})
            refresh()
            onClose()

          }, (error)=>setErrorData(error.response.data))
        } else {
          api.updateTaxRate(id, formData).then((response:any)=>{
            toast.success('Successfully updated tax class.')
            
            getDetailTaxClass()
            setFormData({tax_rates:[{}]})
            refresh()
            onClose()
          }, (error)=>setErrorData(error.response.data))
        }
      }
  return (
    <NxtbnModal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
    >
      <div className="p-4">
        <div className="border mb-4 p-4 rounded-md flex flex-col">
          <div className="flex flex-col md:flex-row gap-2 w-full">
            <div className="flex flex-col w-full pt-6">
              <label htmlFor="country" className="text-sm text-base-300 mb-4">
                Country
              </label>
              <div>
                <SelectStyled
                  name="country"
                  options={country}
                  defaultValue={country.find(
                    (item) => item.value === formData.country
                  )}
                  onChange={onSelectHandler}
                  errorData={errorData}
                />
              </div>
            </div>
            <div className="flex flex-col w-full pt-6">
              <label htmlFor="state" className="text-sm text-base-300">
                State
              </label>
              <div>
                <InputField
                  id="state"
                  type="text"
                  name="state"
                  value={formData?.state || ""}
                  onChange={onChangeHandler}
                  placeholder="State"
                  className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  errorData={errorData}
                />
              </div>
            </div>
            <div className="flex flex-col w-full pt-6">
              <label htmlFor="rate" className="text-sm text-base-300">
                Rate
              </label>
              <div>
                <InputField
                  id="rate"
                  type="number"
                  name="rate"
                  value={formData?.rate || ""}
                  onChange={onChangeHandler}
                  placeholder="0.00"
                  className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                  errorData={errorData}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center  gap-2 pt-6">
            <label htmlFor="is_active" className="text-sm text-base-300">
              Is active
            </label>
            <div>
              <InputField
                id="is_active"
                type="checkbox"
                name="is_active"
                checked={formData?.is_active || ""}
                onChange={(e: any) =>
                  setFormData((prev: any) => ({
                    ...prev,
                    [e.target.name]: e.target.checked,
                  }))
                }
                placeholder="Enter tax class name"
                className="w-full px-5 py-3 bg-secondary-50 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
          </div>
        </div>
        <div className="mt-6 mb-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            onClick={(e: any) =>
              edit ? onSubmit(e, formData.id) : onSubmit(e)
            }
          >
            {edit ? "Update" : "Add"}
          </button>
        </div>
      </div>
    </NxtbnModal>
  );
}

export default TaxRateForm;
